import { TrustPilotMicroCombo as UITrustPilotMicroCombo } from "@jti/ui/components/TrustPilotMicroCombo/TrustPilotMicroCombo";

import type { TrustPilotMicroComboProps } from "./TrustPilotMicroCombo.builder";

export function TrustPilotMicroCombo(props: TrustPilotMicroComboProps) {
  return (
    <UITrustPilotMicroCombo
      width={props.width}
      height={props.height}
      {...(props.theme ? { theme: props.theme } : {})}
    />
  );
}
